
import React from 'react';
import * as S from './icon-button-component.style';
const IconButton : React.FC<IconButtonProps>  = ({ icon, primary, size, disabled, onClick, ariaLabel,children }) => {
    return (
      <S.IconButton
        $primary={primary}
        $size={size}
        disabled={disabled}
        onClick={onClick}
        aria-label={ariaLabel}
      >
        {icon}
        {children}
      </S.IconButton>
    );
  };
  

  export default IconButton;